import { Map } from "immutable";
import { resolveEach } from "redux-resolver";
import * as actionTypes from "./actionTypes";

export const initialState = Map({
  upgradeAvailable: false
});

export default resolveEach(initialState, {
  [actionTypes.UPGRADE_CHECK]: (state, action) =>
    state.set("upgradeAvailable", action.upgradeAvailable)
});



// WEBPACK FOOTER //
// ./app/modules/Upgrade/reducer.js